<template>
    <div>
        <div class="calendar">
            <span @click="openCalendar" class="icon-calendar"></span>
        </div>
        <Dialog :has-backdrop="true" :show="showPicker" @close="closeCalendar">
            <div>
                <h4>{{ title }}</h4>
                <v-date-picker v-if="setMax" :max-date="yesterday" style="border: none" :columns="2" color="gray"
                               v-model="range" is-range></v-date-picker>
                <v-date-picker v-if="!setMax" style="border: none" :columns="2" color="gray" v-model="range"
                               :isRange="isRange"></v-date-picker>
                <div style="display: flex; justify-content: space-between">
                    <AdaButton @click="saveClicked" title="Auswahl bestätigen"></AdaButton>
                    <AdaButton v-if="nullable" @click="$emit('close', null);closeCalendar();"
                               type="pink" :custom-styles="{width: 'fit-content'}"
                               title="Always on"></AdaButton>
                </div>
                <p class="infoText">{{infoText}}</p>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Dialog from "../../components/dialogs/Dialog";
// import Input from "../inputs/Input";
import AdaButton from "../buttons/AdaButton";
import moment from 'moment';

export default {
    name: "DatePicker",
    components: {
        AdaButton,
        Dialog,
        //   Input
    },
    computed: {
        yesterday() {
            return moment().subtract(1, 'days').format('YYYY-MM-DD');
        }
    },
    props: {
        infoText: {
            type: String,
            default: ''
        },
        setMax: {
            type: Boolean,
            default: true
        },
        isRange: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: 'Zeitraum auswählen'
        },
        nullable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            attributes: [
                // This is a single attribute
                {
                    // An optional key can be used for retrieving this attribute later,
                    // and will most likely be derived from your data object
                    // Attribute type definitions
                    highlight: true,  // Boolean, String, Object
                    dot: true,        // Boolean, String, Object
                    bar: true,        // Boolean, String, Object
                    content: 'red',   // Boolean, String, Object
                    // Your custom data object for later access, if needed
                    // We also need some dates to know where to display the attribute
                    // We use a single date here, but it could also be an array of dates,
                    //  a date range or a complex date pattern.
                    dates: new Date(),
                    // You can optionally provide dates to exclude
                    excludeDates: null,
                    // Think of `order` like `z-index`
                    order: 0
                }
            ],
            showPicker: false,
            inputRanges: [],
            range: {
                start: {},
                end: {}
            }
        }
    },
    methods: {
        closeCalendar: function () {
            this.showPicker = false;
            this.range = {
                start: {},
                end: {}
            };
        },
        openCalendar: function () {
            this.showPicker = true;
        },
        saveClicked: function () {
            if (this.range.start instanceof Date && this.range.end instanceof Date) {
                let range = this.formatDate(this.range.start) + ' - ' + this.formatDate(this.range.end);
                this.inputRanges.push(range);
            }
            this.$emit('close', this.range);
            this.closeCalendar();
        },
        formatDate: function (date) {
            let day = date.getDate() + '';
            let month = (date.getMonth() + 1) + '';
            let year = date.getFullYear() + '';
            year = year.substring(2, 4);
            if (day.length === 1) {
                day = '0' + day;
            }
            if (month.length === 1) {
                month = '0' + month;
            }
            return day + '.' + month + '.' + year;
        }
    }
}
</script>

<style lang="scss" scoped>
.datePickerInput.inputContainer {
    margin-bottom: 0px;
}

.infoText {
    max-width: fit-content;
    font-size: 0.9em;
}

.radioWrapper {
    margin-bottom: 1rem;
}

.calendar {
    display: inline-flex;
    align-items: center;
    font-size: 1.5em;
    margin-left: 1rem;
    width: 100%;
    margin-right: 1rem;
}

.calendar span {
    cursor: pointer;
    position: absolute;
}

</style>